import { useEffect, useState } from 'react'
import { fetchFirebaseCloudMessagingList } from '../services'
import { NOTIFICATION_STATUSES } from '../constants'

export const useFirebaseCloudMessagingList = ({ status = NOTIFICATION_STATUSES.UNKNOWN, pageParam = 1 }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [firebaseCloudMessagingList, setFirebaseCloudMessagingList] = useState(null)

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await fetchFirebaseCloudMessagingList({ status, pageParam })

      setFirebaseCloudMessagingList(response.data)
      setData(response)
    } catch (error) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  const refetch = () => {
    fetchData()
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, pageParam])

  return { data, firebaseCloudMessagingList, loading, error, refetch }
}
